import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { products } from '../data/products';
export function Marquee() {
  const reduce = useReducedMotion();
  const names = products.map(p => p.name);
  const row = [...names, ...names];
  return <div className="overflow-hidden border-y border-ink bg-ink py-5 text-sand" aria-label="Ingrediënten" data-id="element-61" data-mp="2ihkye10jsau2">
      <motion.ul className="flex w-max gap-10 whitespace-nowrap" animate={reduce ? undefined : {
      x: ['0%', '-50%']
    }} transition={{
      duration: 40,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-62" data-mp="2diq4o411l1v6">
        {row.map((n, i) => <li key={i} className="flex items-center gap-10 font-display text-3xl italic" aria-hidden={i >= names.length} data-id="element-63" data-mp="3193z2173ncsx" data-mpi={i}>
            {n}
            <span className="h-1.5 w-1.5 rounded-full bg-clay" aria-hidden="true" data-id="element-64" data-mp="2xampzc44bs8v" />
          </li>)}
      </motion.ul>
    </div>;
}